import { getImageUrl } from 'lib/image/imageUtils'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

const Logo = styled.div`
  background-image: url(${getImageUrl('lux-plus-month-calendar-icon-static-4x')});
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  min-width: ${rem(48)};
  height: ${rem(80)};
  width: ${rem(80)};
`

interface Props {
  className?: string
}

function LuxPlusMonthCalendarLogo(props: Props) {
  return <Logo {...props} />
}

export default LuxPlusMonthCalendarLogo
